/* RVA: smooth close for auto-opened mobile sub-menus.
   The "Optimize mobile menu layout" setting renders 2nd-level (tier-3) sub-menus open by
   giving their container an inline height:auto. CSS can't animate from auto to 0, so the
   theme's close would snap. This converts that auto to the real pixel height, so the theme's
   existing close transition (px -> 0) animates smoothly. The caret keeps working normally. */
(function () {
  function fixOpenTierHeights() {
    var drawer = document.querySelector('.mobile-navigation-drawer');
    if (!drawer) return;
    if (getComputedStyle(drawer).display === 'none') return; // desktop viewport: not shown, not measurable
    var containers = drawer.querySelectorAll(
      '.navigation__tier-2-container .navigation__item--open > .navigation__tier-3-container'
    );
    containers.forEach(function (el) {
      var h = el.style.height;
      if (h === 'auto' || h === '') {
        var inner = el.firstElementChild;
        if (inner && inner.clientHeight) {
          el.style.height = inner.clientHeight + 'px';
        }
      }
    });
  }

  function onBodyClassChange() {
    if (document.body.classList.contains('reveal-mobile-nav')) {
      requestAnimationFrame(fixOpenTierHeights);
    }
  }

  function init() {
    // On mobile the drawer is display:block even while closed, so heights are measurable now.
    fixOpenTierHeights();
    // Safety net for lazy build / viewport resize: re-measure when the drawer is revealed.
    new MutationObserver(onBodyClassChange).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
